import { Card, Upload, Button, message, Space, Popconfirm, Row, Col, Image } from 'antd'
import { UploadOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import axios from 'axios'
import dayjs from 'dayjs'

// الأنواع الثلاثة المدعومة — يجب أن تطابق ALLOWED_TYPES بالباك إند
// (pdfDesignOptions.js) حرفياً
const SECTIONS = [
  { type: 'header', label: 'صورة رأس الصفحة' },
  { type: 'footer', label: 'صورة أسفل الصفحة' },
  { type: 'background', label: 'صورة الخلفية' },
]

function DefaultPdfDesignSettings() {
  const [statusMap, setStatusMap] = useState({})
  const [loading, setLoading] = useState(true)
  const [uploadingType, setUploadingType] = useState(null)

  const token = localStorage.getItem('token')
  const headers = { Authorization: `Bearer ${token}` }

  useEffect(() => {
    fetchStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchStatus = async () => {
    setLoading(true)
    try {
      const res = await axios.get('/api/settings/pdf-design', { headers })
      setStatusMap(res.data)
    } catch (err) {
      message.error(err.response?.data?.error || 'خطأ في جلب البيانات')
    }
    setLoading(false)
  }

  const handleUpload = async (type, file) => {
    setUploadingType(type)
    try {
      const formData = new FormData()
      formData.append('file', file)
      await axios.post(`/api/settings/pdf-design/${type}`, formData, {
        headers: { ...headers, 'Content-Type': 'multipart/form-data' }
      })
      message.success('تم رفع الصورة بنجاح ✅')
      fetchStatus()
    } catch (err) {
      message.error(err.response?.data?.error || 'خطأ في رفع الصورة')
    }
    setUploadingType(null)
  }

  const handleDelete = async (type) => {
    try {
      await axios.delete(`/api/settings/pdf-design/${type}`, { headers })
      message.success('تم الحذف')
      fetchStatus()
    } catch (err) {
      message.error(err.response?.data?.error || 'خطأ في الحذف')
    }
  }

  return (
    <Card title="خيارات التصميم الافتراضي للفاتورة" loading={loading}>
      <p style={{ color: '#888', marginBottom: 20 }}>
        هذه الصور تُستخدَم لتخصيص التصميم الافتراضي للفاتورة. يمكنك رفع صورة
        لكل عنصر على حدة أو تركه فارغاً.
      </p>

      <Row gutter={24}>
        {SECTIONS.map(section => {
          const status = statusMap[section.type]
          return (
            <Col span={8} key={section.type}>
              <Card
                type="inner"
                title={section.label}
                style={{ marginBottom: 16, textAlign: 'center' }}
              >
                {status ? (
                  <Space direction="vertical" style={{ width: '100%' }}>
                    <Image
                      src={`/api/settings/pdf-design/${section.type}/preview?t=${status.updated_at}`}
                      alt={section.label}
                      style={{ maxWidth: '100%', maxHeight: 120, objectFit: 'contain' }}
                      preview={{ mask: 'عرض بالحجم الكامل' }}
                    />
                    <span style={{ fontSize: 12, color: '#389e0d' }}>
                      <CheckCircleOutlined /> {status.file_name}
                    </span>
                    <span style={{ fontSize: 11, color: '#aaa' }}>
                      {dayjs(status.updated_at).format('YYYY-MM-DD HH:mm')}
                    </span>
                  </Space>
                ) : (
                  <div style={{ color: '#ccc', padding: '20px 0' }}>لا توجد صورة بعد</div>
                )}

                <div style={{ marginTop: 12 }}>
                  <Upload
                    accept="image/*"
                    showUploadList={false}
                    customRequest={({ file }) => handleUpload(section.type, file)}
                    disabled={uploadingType === section.type}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      loading={uploadingType === section.type}
                      block
                    >
                      {status ? 'استبدال' : 'رفع صورة'}
                    </Button>
                  </Upload>

                  {status && (
                    <Popconfirm
                      title="حذف هذه الصورة؟"
                      okText="نعم" cancelText="لا"
                      onConfirm={() => handleDelete(section.type)}
                    >
                      <Button danger icon={<DeleteOutlined />} block style={{ marginTop: 8 }}>
                        حذف
                      </Button>
                    </Popconfirm>
                  )}
                </div>
              </Card>
            </Col>
          )
        })}
      </Row>
    </Card>
  )
}

export default DefaultPdfDesignSettings
